<template>
  <div>
    <div
      v-show="this.$route.path == '/personal/myAccount/expenseRecord/detail'"
    >
      <h3>
        消费记录_详情
      </h3>
      <div class="incomebox">
        <div class="choosetime clearfix">
          <p class="fl userinfo">
            账户余额：{{ userInfo.yuanBi }} 源币 l {{ userInfo.coin }} 赠币
          </p>
          <button class="inquirebtn defaultbtn fr" @click="timeBtn">
            查询
          </button>
          <div class="fr">
            <span class="demonstration"> 起止时间：</span>
            <el-date-picker
              v-model="allChoooseTime"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
        </div>
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          class="table-cell"
        >
          <el-table-column prop="bookName" align="center" label="名称">
          </el-table-column>
          <el-table-column prop="consumeType" align="center" label="类型">
          </el-table-column>
          <el-table-column prop="chapterCount" align="center" label="明细">
          </el-table-column>
          <el-table-column
            prop="yuanBi"
            style="color:#48a2df"
            align="center"
            label="交易金额"
          >
          </el-table-column>
          <el-table-column
            prop="lastCreateTime"
            width="180"
            align="center"
            label="最后一次消费时间"
          >
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <a
                style="color:#48A2DF;fonr-size:14px;display:block;text-align:center"
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                >查看详情</a
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          :hide-on-single-page="true"
          layout="prev, pager, next"
          :total="totalCount"
          :pager-count="pagecount"
          :current-page="Current"
          class="paginnation-book"
          @current-change="currentChoose"
        >
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { getuserInfo } from "@/api/login";
import { groupbook } from "@/api/pay";
export default {
  data() {
    return {
      pageName: "书籍-消费记录",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      allChoooseTime: [],
      tableData: [],
      pagecount: 5,
      payType: "0",
      userInfo: {},
      totalCount: 0,
      Current: 1
    };
  },
  created() {
    this.$nextTick(() => {
      this.getInfo();
      this.getgroupbook();
      this.$route.meta.name = "详情";
      this.payType = this.$route.query.id;
    });
  },
  methods: {
    // 获取用户信息
    async getInfo() {
      let res = await getuserInfo();
      this.userInfo = res.data;
    },
    // 获取交易类型组
    async getgroupbook() {
      let res = await groupbook();
      if (res.success) {
        this.tableData = res.data.items;
        this.tableData.forEach(item => {
          item.chapterCount = `已购${item.chapterCount}章`;
          item.yuanBi = `${item.yuanBi}源币`;
        });
        this.totalCount = Number(res.data.totalCount);
        this.Current = Number(res.data.pageNum);
      }
    },
    getBookList(beginDate, endDate, pageNo, pageSize) {
      groupbook({ beginDate, endDate, pageNo, pageSize })
        .then(res => {
          if (res.success) {
            this.tableData = res.data.items;
            this.tableData.forEach(item => {
              item.chapterCount = `已购${item.chapterCount}章`;
              item.yuanBi = `${item.yuanBi}源币`;
            });
            this.Current = Number(res.data.pageNum);
            this.totalCount = Number(res.data.totalCount);
          }
        })
        .catch(() => {});
    },
    timeBtn() {
      if (this.allChoooseTime) {
        this.getBookList(this.allChoooseTime[0], this.allChoooseTime[1], 1, 10);
      } else {
        this.getBookList("", "", 1, 10);
      }
    },
    currentChoose(pageNo) {
      if (this.allChoooseTime) {
        this.getBookList(
          this.allChoooseTime[0],
          this.allChoooseTime[1],
          pageNo,
          10
        );
      } else {
        this.getBookList("", "", pageNo, 10);
      }
    },
    handleClick(row) {
      this.$router.push({
        path: `/personal/myAccount/expenseRecord/detail/account`,
        query: { id: row.bookId, name: row.bookName }
      });
    }
  }
};
</script>
<style>
.cell {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 23px;
}
</style>

<style lang="stylus" scoped>
.incomebox
  padding 20px 24px
  .lineimgbox
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(211, 211, 211, 1)
    margin-bottom 20px
  .choosetime
    height 54px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(211, 211, 211, 1)
    line-height 54px
    margin-bottom 20px
    font-size 14px
    font-family PingFangSC-Regular
    font-weight 400
    color rgba(51, 51, 51, 1)
    .inquirebtn
      margin 13px 20px
    .userinfo
        margin-left 28px
        font-weight:600;
        color:rgba(154,154,154,1);
  .paginnation-book
    position absolute
    bottom 30px
    right 24px
</style>
